import { MonthZeroBased } from '@deltasierra/shared';
import * as React from 'react';
import { CalendarDayInfo } from './CalendarDay';

export interface CalendarContextContent {
    days: CalendarDayInfo[];
    decrementMonth?: () => void;
    displayMonth: MonthZeroBased;
    displayYear: number;
    hoveredDate?: Date;
    incrementMonth?: () => void;
    isSelectingTo?: boolean;
    onSelectDate?: (date?: Date) => void;
    selected?: Date;
    selectedTo?: Date;
    setHoveredDate?: (date?: Date) => void;
    setSelected?: (val: Date | undefined) => void;
    setSelectedTo?: (val?: Date  ) => void;
}

export const CalendarContext = React.createContext<CalendarContextContent>({
    days: [],
    displayMonth: 0,
    displayYear: 2000,
});
export const useCalendar = (): CalendarContextContent => React.useContext(CalendarContext);
